export const DEFAULTS = {
  MULTIMATCH_FIELDS: ['orig_order'],
  ROWS_STATUSES: {
    ready_for_import: {
      icon: 'mdi-check',
      color: 'primary'
    },
    ask_customer: {
      icon: 'mdi-account-alert',
      color: 'yellow'
    },
    needs_change: {
      icon: 'mdi-alert',
      color: 'error'
    },
    needs_code_change: {
      icon: 'mdi-alert',
      color: '#ff8300'
    },
    ignore: {
      icon: 'mdi-eye-off-outline',
      color: '#9F9B9B'
    },
    imported: {
      icon: 'mdi-dog',
      color: '#7DAC1E'
    },
    not_reviewed: {
      icon: 'mdi-dots-horizontal',
      color: 'secondary'
    },
    ignore_by_customer: {
      icon: 'mdi-account-minus',
      color: '#9F9B9B'
    },
    ignore_by_multimatch: {
      icon: 'mdi-eye-off-outline',
      color: '#9F9B9B'
    },
    needs_re_review: {
      icon: 'mdi-brain',
      color: 'primary'
    },
    supply: {
      icon: 'mdi-star',
      color: '#F8B752'
    },
    asis: {
      icon: 'mdi-alpha-a-circle-outline',
      color: '#ad0303'
    },
    obsolete: {
      icon: 'mdi-alpha-o-circle-outline',
      color: '#939022'
    },
    unmatched: {
      icon: 'mdi-close-octagon-outline',
      color: '#D7574A'
    },
    correct_by_multimatch: {
      icon: 'mdi-check-box-multiple-outline',
      color: '#43A9D2'
    },
    no_multimatch: {
      icon: 'mdi-format-line-style',
      color: '#835301'
    },
    compounded: {
      icon: 'mdi-atom-variant',
      color: '#843a00'
    },
    ready_for_re_match: {
      icon: 'mdi-alert-circle-check-outline',
      color: '#356c6c'
    },
    import_verified_by_customer: {
      icon: 'mdi-account-check',
      color: '#25ce1f'
    },
    do_not_ignore: {
      icon: 'mdi-disc-alert',
      color: '#356c6c'
    }
  },
  SHOW_STATUSES: {
    default: [
      'ready_for_import',
      'ask_customer',
      'needs_change',
      'needs_code_change',
      'needs_re_review',
      'supply',
      'asis',
      'ignore',
      'ignore_by_customer',
      'no_multimatch',
      'compounded',
      'ready_for_re_match',
      'do_not_ignore'
    ],
    customer: [
      'ready_for_import',
      'needs_change',
      'needs_code_change',
      'asis',
      'needs_re_review',
      'supply',
      'ignore_by_customer'
    ]
  },
  FILTERS_STATUSES: {
    default: [
      'ready_for_import',
      'correct_by_multimatch',
      'imported',
      'not_reviewed',
      'unmatched',
      'ask_customer',
      'needs_change',
      'needs_code_change',
      'needs_re_review',
      'supply',
      'asis',
      'ignore',
      'ignore_by_customer',
      'no_multimatch',
      'compounded',
      'ready_for_re_match',
      'import_verified_by_customer',
      'do_not_ignore'
    ],
    customer: [
      'ready_for_import',
      'correct_by_multimatch',
      'imported',
      'not_reviewed',
      'unmatched',
      'ask_customer',
      'needs_change',
      'needs_code_change',
      'needs_re_review',
      'supply',
      'asis',
      'ignore',
      'ignore_by_customer'
    ]
  },
  MATCHER: {
    CUSTOM_PARAMETERS: {
      OUTPUT_MODE: ['normal', 'upload', 'yonly'],
      SALES_DROP: ['year'],
      GROUPNAMES: ['pva', 'nva'],
      LAB_ID_MODES: ['normal', 'all', 'strong'],
      RX_IDS: ['idexx'],
      IN_HOUSE_FILTERS: ['hint'],
      IN_HOUSE_SRCS: ['name', 'namewins'],
      VENDOR_FILTERS: ['normal', 'nameonly', 'hint'],
      CATEGORY_CLASSIFICATIONS: ['standard'],
      CUT_OFFS: ['firm', 'threshold', 'normal'],
      NEVER_SOLDS: ['off', 'on', 'price0'],
      PASSES: ['pass1', 'pass2', 'pass3', 'final'],
      UPDATED_SRC_FILES: ['new'],
      OFF_ON_OPTIONS: ['off', 'on'],
      MERGE_DISPENSING_FEED_OPTIONS: [
        'merge labs and procedures',
        'clear labs and procedure',
        'never',
        'always'
      ],
      // QOH - quantity on hand
      DONT_CLEAR_QOH_OPTIONS: ['normal', 'off'],
      CLEAR_MINIMUM_PRICE_OPTIONS: ['on', 'off', 'all'],
      LOCALE_OPTIONS: [
        {
          text: 'English (US)',
          value: 'en-US'
        },
        {
          text: 'Spanish (ES)',
          value: 'es-ES'
        }
      ],
      UNIT_SYSTEM: ['imperial', 'metric'],
      LAB_MATCHING_TECHNIQUE: ['firm', 'fuzzy']
    },
    CONTEXT: {
      clinic: '',
      labidmode: '',
      officialname: '',
      salesdrop: '',
      salesthreshold: 0,
      cutoff: '',
      cutoffmonths: 0,
      neversold: '',
      pass: '',
      outputmode: '',
      locale: ['en']
    },
    FILES_TYPES: [
      { header: 'Internal formats' },
      { divider: true },
      { text: 'common', value: 'common' },
      { text: 'cornerstoneprice', value: 'cornerstoneprice' },
      { text: 'localfoodcatalog', value: 'localfoodcatalog' },
      { text: 'pricelistmatcher', value: 'pricelistmatcher' },

      { header: 'Сonstantly used formats' },
      { divider: true },

      { text: 'avimark', value: 'avimark' },
      { text: 'avimark3', value: 'avimark3' },
      { text: 'impromed', value: 'impromed' },

      { header: 'Other formats' },
      { divider: true },
      { text: 'vetter', value: 'vetter' },
      { text: 'vetter2', value: 'vetter2' },
      { text: 'avimark2', value: 'avimark2' },
      { text: 'avimarkexport', value: 'avimarkexport' },
      { text: 'cornerstone', value: 'cornerstone' },
      { text: 'dvm', value: 'dvm' },
      { text: 'dvmax', value: 'dvmax' },
      { text: 'dvmax2', value: 'dvmax2' },
      { text: 'dvmax3', value: 'dvmax3' },
      { text: 'vtech', value: 'vtech' },
      { text: 'vtechold', value: 'vtechold' },
      { text: 'vtechamc', value: 'vtechamc' },
      { text: 'impromedbig', value: 'impromedbig' },
      { text: 'impromedadvantage', value: 'impromedadvantage' },
      { text: 'infinityold', value: 'infinityold' },
      { text: 'infinitynew', value: 'infinitynew' },
      { text: 'infinityoldmulti', value: 'infinityoldmulti' },
      { text: 'psi', value: 'psi' },
      { text: 'ezvet', value: 'ezvet' },
      { text: 'evetpracticeinv', value: 'evetpracticeinv' },
      { text: 'evetpracticelabs', value: 'evetpracticelabs' },
      { text: 'evetpracticeprocedures', value: 'evetpracticeprocedures' },
      { text: 'evetpractice', value: 'evetpractice' },
      { text: 'heal', value: 'heal' },
      { text: 'rhapsody', value: 'rhapsody' },
      { text: 'rhapsodycatalog', value: 'rhapsodycatalog' },
      { text: 'vetterhistory', value: 'vetterhistory' },
      { text: 'diagnosislist', value: 'diagnosislist' },
      { text: 'pva', value: 'pva' },
      { text: 'mwi', value: 'mwi' },
      { text: 'vetcove', value: 'vetcove' },
      { text: 'chewy', value: 'chewy' },
      { text: 'chewydrug', value: 'chewydrug' },
      { text: 'chewyrxfood', value: 'chewyrxfood' }
    ],
    LABS: [
      'idexx',
      'abaxis',
      'animal genetics',
      'animal health diagnostic center at cornell',
      'antech',
      'bloodhound',
      'colorado state',
      'dcpah',
      'ellie diagnostics',
      'heska',
      'kansas state university',
      'kord',
      'lacuna diagnostics',
      'lsu',
      'marshfield',
      'michiganstate',
      'micrim labs',
      'microvet',
      'miravista diagnostics',
      'national bio vet laboratory',
      'osu',
      'phoenix lab',
      'professional veterinary pathology services',
      'spectrum allergy',
      'spectrum labs',
      'sylvan',
      'utenn',
      'texas a&m veterinary medical diagnostic laboratory',
      'true north veterinary diagnostics',
      'laboratory services at uc davis',
      'ucsd',
      'university of florida',
      'university of georgia',
      'university of guelph',
      'university of missouri',
      'university of nebraska-lincoln',
      'varl',
      'vdi',
      'vdx',
      'vetek labs',
      'vetgen',
      'washington state university',
      'zoetis',
      'znlabs'
    ]
  },
  LINKS_TYPES_MAP: {
    CUSTOMER_LINK: 'protected_link',
    MIG_PAL_LINK: 'mig_pal_link'
  }
};
